export const MARKET_TYPE_MAP: any = {
    load: 1,
    lorry: 2,
    loads: 1,
    lorries: 2
};
export const MARKET_TYPE = {
    LOADS: "loads",
    LORRIES: "lorries",
    LOAD: "load",
    Lorry: "lorry"
};

export enum MarketPlaceType {
    LOAD = "load",
    LORRY = "lorry"
}
